import PrivacyVersionLayout from './PrivacyVersionLayout'

export default function PrivacyV103() {
  return (
    <PrivacyVersionLayout version="1.0.3" date="21/01/2025">
      <div dangerouslySetInnerHTML={{ __html: privacyContent }} />
    </PrivacyVersionLayout>
  )
}

const privacyContent = `
  <p>Titolare del trattamento ai sensi delle leggi vigenti è la società <strong>ItalConnect S.r.l.</strong> (d'ora innanzi per brevità "Società") con sede legale in Via Alessandro Volta 24, 20099 Sesto San Giovanni (MI) P. IVA IT10663330966, indirizzo e-mail <strong>amministrazione@italconnectsrl.it</strong>, nella persona del suo Rappresentante Legale Dott. Luigi Zavatta, in qualità di Titolare del Trattamento.</p>
  <p>Il Data Protection Officer ("DPO") nominato dal Titolare ai sensi dell'art. 37 e seguenti del Regolamento UE 2016/679 (GDPR) è la società Beet.it S.r.l. (P.IVA 01736190595). È possibile contattare il DPO inviando una e-mail all'indirizzo: <strong>dpoitalconnectsrl@beet.it</strong></p>
  
  <h2>1. Finalità del trattamento, basi giuridiche e obbligatorietà del conferimento</h2>
  <p>Il trattamento dei dati raccolti dal sito è effettuato per le finalità di seguito indicate:</p>
  <ul>
    <li><strong>1.1 Statistica (analisi):</strong> Raccolta di dati e informazioni in forma esclusivamente aggregata e anonima al fine di verificare il corretto funzionamento del sito.<br/><strong>Base giuridica:</strong> Interesse legittimo del titolare del trattamento (art. 6, par. 1, lett. f) GDPR).<br/><strong>Obbligatorietà del conferimento:</strong> Non obbligatorio.</li>
    <li><strong>1.2 Sicurezza:</strong> Raccolta di dati e informazioni al fine di tutelare la sicurezza del sito e degli utenti.<br/><strong>Base giuridica:</strong> Adempimento di un obbligo di legge (art. 6, par. 1, lett. c) GDPR).<br/><strong>Obbligatorietà del conferimento:</strong> Obbligatorio.</li>
    <li><strong>1.3 Esecuzione dei servizi richiesti:</strong> I dati personali forniti saranno trattati per finalità strettamente connesse all'esecuzione dei servizi richiesti.<br/><strong>Base giuridica:</strong> Esecuzione di un contratto (art. 6, par. 1, lett. b) GDPR).<br/><strong>Obbligatorietà del conferimento:</strong> Obbligatorio.</li>
    <li><strong>1.4 Marketing:</strong> Utilizzo dei dati personali, solo previo consenso esplicito, per inviare comunicazioni promozionali.<br/><strong>Base giuridica:</strong> Consenso dell'interessato (art. 6, par. 1, lett. a) GDPR).<br/><strong>Obbligatorietà del conferimento:</strong> Facoltativo.</li>
    <li><strong>1.5 Cessione dei dati a terzi:</strong> Trasferimento dei dati personali a terzi per finalità di marketing, previo consenso.<br/><strong>Base giuridica:</strong> Consenso dell'interessato (art. 6, par. 1, lett. a) GDPR).<br/><strong>Obbligatorietà del conferimento:</strong> Facoltativo.</li>
  </ul>
  
  <h2>2. Dati raccolti</h2>
  <p>Il presente sito raccoglie dati degli utenti in due modi: dati raccolti in maniera automatizzata e dati raccolti durante la navigazione degli Utenti.</p>
  <p>Possono essere raccolte le seguenti informazioni:</p>
  <ul>
    <li>Internet Protocol address (IP);</li>
    <li>Tipo di browser;</li>
    <li>Parametri del dispositivo usato per connettersi al sito;</li>
    <li>Nome dell'internet service provider (ISP);</li>
    <li>Data e orario di visita;</li>
    <li>Pagina web di provenienza del visitatore (referral) e di uscita;</li>
    <li>Eventualmente il numero di click.</li>
  </ul>
  
  <h2>3. Dati conferiti volontariamente</h2>
  <p>Il sito può raccogliere altri dati in caso di utilizzo volontario di servizi da parte degli utenti:</p>
  <ul>
    <li>Nome e cognome;</li>
    <li>Numero di telefono.</li>
  </ul>
  
  <h2>4. Luogo del trattamento</h2>
  <p>I dati sono trattati presso la sede del Titolare del Trattamento, e presso il datacenter del web Hosting (Aruba S.p.A).</p>
  
  <h2>5. Destinatari dei dati</h2>
  <p>I dati di natura personale forniti saranno comunicati a destinatari, che tratteranno i dati in qualità di responsabili (art. 28 del Reg. UE 2016/679) e/o in qualità di persone fisiche che agiscono sotto l'autorità del Titolare e del Responsabile.</p>
  
  <h2>6. Cessione dei dati</h2>
  <p>I dati personali, previo consenso espresso per tale finalità, potranno essere ceduti per finalità commerciali e di marketing. La lista dei soggetti terzi ai quali potranno essere ceduti i dati:</p>
  <ul>
    <li><strong>ENI PLENITUDE S.P.A. SOCIETA' BENEFIT,</strong> con sede in Milano, Via Giovanni Lorenzini n. 4 – Partita IVA 12300020158</li>
    <li><strong>ENEL ENERGIA S.P.A.,</strong> con sede legale in Roma, via Luigi Boccherini n. 15 – Partita IVA 06655971007</li>
    <li><strong>SKY ITALIA S.R.L.,</strong> con sede legale in Milano, via Monte Penice n. 7 – Partita IVA 04619241005</li>
    <li><strong>TIM S.P.A.,</strong> con sede legale in Milano, Via Gaetano Negri n° 1 – Partita IVA 00488410010</li>
    <li><strong>SENTRA S.P.A.,</strong> con sede legale in Roma, viale Citta' d'Europa n. 39 – Partita IVA 12657501008</li>
    <li><strong>LUCE E GAS ITALIA S.P.A.,</strong> con sede legale in Torino, Corso Svizzera 185bis – Partita IVA 07463650965</li>
    <li><strong>AGN ENERGIA S.P.A.,</strong> con sede legale in Volpiano, Via Amalfi 6 – Partita IVA 06170180019</li>
    <li><strong>EDISON S.P.A.,</strong> con sede legale in Milano, Foro Buonaparte 31 – Partita IVA 08263330014</li>
  </ul>
  
  <h2>7. Periodo di conservazione dei dati</h2>
  <p>Il periodo di conservazione dei dati personali varia in base alla finalità del trattamento:</p>
  <ul>
    <li><strong>Finalità di esecuzione dei servizi:</strong> Per il tempo necessario all'esecuzione del servizio.</li>
    <li><strong>Finalità di marketing:</strong> Per un periodo massimo di 6 mesi, salvo revoca del consenso.</li>
    <li><strong>Finalità di cessione a terzi:</strong> Per un periodo di 36 mesi dalla cessione.</li>
    <li><strong>Finalità di sicurezza:</strong> Per un periodo massimo di 30 giorni.</li>
    <li><strong>Finalità di analytics:</strong> Per un periodo massimo di 6 mesi in forma anonima.</li>
  </ul>
  
  <h2>8. Trasferimento dei dati in paesi extra UE</h2>
  <p>Il presente sito potrebbe condividere alcuni dei dati raccolti con servizi localizzati al di fuori dell'area dell'Unione Europea, in base alla decisione di adeguatezza "EU-US Data Privacy Framework".</p>
  
  <h2>9. Misure di sicurezza</h2>
  <p>Trattiamo i dati dei visitatori/utenti in maniera lecita e corretta, adottando le opportune misure di sicurezza volte ad impedire accessi non autorizzati, utilizzando il software Secure Sockets Layer (SSL).</p>
  
  <h2>10. Diritti dell'Interessato</h2>
  <p>Con riferimento ai dati personali trattati dalla Società, Lei ha il diritto di esercitare i seguenti diritti ai sensi del GDPR:</p>
  <ul>
    <li>Diritto di accesso (art. 15 GDPR)</li>
    <li>Diritto di rettifica (art. 16 GDPR)</li>
    <li>Diritto alla cancellazione (art. 17 GDPR)</li>
    <li>Diritto di limitazione del trattamento (art. 18 GDPR)</li>
    <li>Diritto alla portabilità dei dati (art. 20 GDPR)</li>
    <li>Diritto di opposizione (art. 21 GDPR)</li>
    <li>Diritto di non essere sottoposto a decisioni automatizzate (art. 22 GDPR)</li>
    <li>Diritto di revocare il consenso</li>
    <li>Diritto di proporre reclamo al Garante Privacy</li>
  </ul>
  <p>Per esercitare i Suoi diritti, può inviare una richiesta scritta al Titolare del trattamento all'indirizzo e-mail: <strong>amministrazione@italconnectsrl.it</strong> oppure al DPO all'indirizzo: <strong>dpoitalconnectsrl@beet.it</strong></p>
`
